import { lazy } from 'react'

const createLazyNamedPage = (loader, exportName) => {
  let pendingModulePromise

  const loadModule = () => {
    if (!pendingModulePromise) {
      pendingModulePromise = loader()
    }

    return pendingModulePromise
  }

  const LazyPage = lazy(() => loadModule().then((module) => ({ default: module[exportName] })))

  LazyPage.preload = loadModule

  return LazyPage
}

const llmEvaluationLoader = () => import('@/pages/LLMEvaluation')
const renewalHealthLoader = () => import('@/pages/RenewalHealth')
const chargeCodeMappingsLoader = () => import('@/pages/ChargeCodeMappings')
const chargeCodeExplorerLoader = () => import('@/pages/ChargeCodeExplorer')
const activeProductsLoader = () => import('@/pages/ActiveProducts')
const accountSlackNotificationsLoader = () => import('@/pages/AccountSlackNotifications')
const assistantBridgePackagesLoader = () => import('@/pages/AssistantBridgePackages')
const accountManagementLoader = () => import('@/pages/AccountManagementDashboard')
const yardiEtlGeneratorLoader = () => import('@/pages/YardiEtlGenerator')
const businessReviewRoiLoader = () => import('@/pages/BusinessReviewRoi')
const customerMrrLoader = () => import('@/pages/SnowflakeMrrByCustomer')
const routeActivityLoader = () => import('@/pages/RouteActivity')
const conversationQaLoader = () => import('@/pages/ConversationQA')
const conversationQaQualityLoader = () => import('@/pages/ConversationQA/QualityPage')
const frontEmailListsLoader = () => import('@/pages/FrontEmailLists')
const entrataIntegrationDashboardLoader = () => import('@/pages/EntrataIntegrationDashboard')
const appWorkResidentsLoader = () => import('@/pages/AppWorkResidents')
export const AppWorkResidentsPage = createLazyNamedPage(
  appWorkResidentsLoader,
  'AppWorkResidentsPage',
)
const propertyDataHealthLoader = () => import('@/pages/PropertyDataHealth')
export const PropertyDataHealthPage = createLazyNamedPage(
  propertyDataHealthLoader,
  'PropertyDataHealthPage',
)
const portfolioAssignmentsLoader = () => import('@/pages/PortfolioAssignments')
const portfolioOnboardingLoader = () => import('@/pages/PortfolioOnboarding')
const leasingManagementLoader = () => import('@/pages/LeasingManagement')
const surveyControlLoader = () => import('@/pages/SurveyControl')
const propertyFaqCollectorLoader = () => import('@/pages/PropertyFaqCollector')
const learnedFaqsLoader = () => import('@/pages/LearnedFaqs')
const answerCardsLoader = () => import('@/pages/AnswerCards')
const publicMarkdownDocumentsLoader = () => import('@/pages/PublicMarkdownDocuments')
const leaseAuditReviewLoader = () => import('@/pages/LeaseAuditReview')
const auditChartersLoader = () => import('@/pages/AuditCharters')
const auditTrialsLoader = () => import('@/pages/AuditTrials')
const pgBossDashboardLoader = () => import('@/pages/PgBossDashboard')
const voiceModeLoader = () => import('@/pages/VoiceMode')
const voiceOpsLoader = () => import('@/pages/VoiceOps')
const knowledgeGapsLoader = () => import('@/pages/KnowledgeGaps')
const recordPaymentsLoader = () => import('@/pages/RecordPayments')
export const KnowledgeGapsPage = createLazyNamedPage(knowledgeGapsLoader, 'KnowledgeGapsPage')
export const RecordPaymentsPage = createLazyNamedPage(recordPaymentsLoader, 'RecordPaymentsPage')

export const LLMEvaluationLayout = createLazyNamedPage(llmEvaluationLoader, 'LLMEvaluationLayout')
export const AnalysisList = createLazyNamedPage(llmEvaluationLoader, 'AnalysisList')
export const AnalysisDetail = createLazyNamedPage(llmEvaluationLoader, 'AnalysisDetail')
export const PromptEditor = createLazyNamedPage(llmEvaluationLoader, 'PromptEditor')
export const ComparisonView = createLazyNamedPage(llmEvaluationLoader, 'ComparisonView')

export const RenewalHealthLayout = createLazyNamedPage(renewalHealthLoader, 'RenewalHealthLayout')
export const RenewalHealthOverview = createLazyNamedPage(
  renewalHealthLoader,
  'RenewalHealthOverview',
)
export const RenewalHealthDetail = createLazyNamedPage(renewalHealthLoader, 'RenewalHealthDetail')

export const ChargeCodeMappingsPage = createLazyNamedPage(
  chargeCodeMappingsLoader,
  'ChargeCodeMappingsPage',
)
export const ChargeCodeExplorerPage = createLazyNamedPage(
  chargeCodeExplorerLoader,
  'ChargeCodeExplorerPage',
)
export const ActiveProductsPage = createLazyNamedPage(activeProductsLoader, 'ActiveProductsPage')
export const AccountSlackNotificationsPage = createLazyNamedPage(
  accountSlackNotificationsLoader,
  'AccountSlackNotificationsPage',
)
export const AssistantBridgePackagesPage = createLazyNamedPage(
  assistantBridgePackagesLoader,
  'AssistantBridgePackagesPage',
)
export const AccountManagementLayout = createLazyNamedPage(
  accountManagementLoader,
  'AccountManagementLayout',
)
export const AccountManagementOverview = createLazyNamedPage(
  accountManagementLoader,
  'AccountManagementOverview',
)
export const AccountManagementPortfolioBreakdown = createLazyNamedPage(
  accountManagementLoader,
  'AccountManagementPortfolioBreakdown',
)
export const AccountManagementAccountDetail = createLazyNamedPage(
  accountManagementLoader,
  'AccountManagementAccountDetail',
)
export const YardiEtlGeneratorPage = createLazyNamedPage(
  yardiEtlGeneratorLoader,
  'YardiEtlGeneratorPage',
)
export const BusinessReviewRoiPage = createLazyNamedPage(
  businessReviewRoiLoader,
  'BusinessReviewRoiPage',
)
export const SnowflakeMrrByCustomerPage = createLazyNamedPage(
  customerMrrLoader,
  'SnowflakeMrrByCustomerPage',
)
export const RouteActivityPage = createLazyNamedPage(routeActivityLoader, 'RouteActivityPage')
export const ConversationQAPage = createLazyNamedPage(conversationQaLoader, 'ConversationQAPage')
export const ConversationQAQualityPage = createLazyNamedPage(
  conversationQaQualityLoader,
  'ConversationQAQualityPage',
)
export const FrontEmailListsPage = createLazyNamedPage(frontEmailListsLoader, 'FrontEmailListsPage')
export const EntrataIntegrationDashboardPage = createLazyNamedPage(
  entrataIntegrationDashboardLoader,
  'EntrataIntegrationDashboardPage',
)
export const PortfolioAssignmentsPage = createLazyNamedPage(
  portfolioAssignmentsLoader,
  'PortfolioAssignmentsPage',
)
export const PortfolioOnboardingPage = createLazyNamedPage(
  portfolioOnboardingLoader,
  'PortfolioOnboardingPage',
)
export const LeasingManagementPage = createLazyNamedPage(
  leasingManagementLoader,
  'LeasingManagementPage',
)

export const SurveyControlLayout = createLazyNamedPage(surveyControlLoader, 'SurveyControlLayout')
export const SurveyControlOverview = createLazyNamedPage(
  surveyControlLoader,
  'SurveyControlOverview',
)
export const SurveyControlAccountDetail = createLazyNamedPage(
  surveyControlLoader,
  'SurveyControlAccountDetail',
)
export const SurveyControlPropertyDetail = createLazyNamedPage(
  surveyControlLoader,
  'SurveyControlPropertyDetail',
)
export const SurveyControlSettingDetail = createLazyNamedPage(
  surveyControlLoader,
  'SurveyControlSettingDetail',
)
export const SurveyControlBulkOperations = createLazyNamedPage(
  surveyControlLoader,
  'SurveyControlBulkOperations',
)
export const SurveyControlChangeLogs = createLazyNamedPage(
  surveyControlLoader,
  'SurveyControlChangeLogs',
)
export const SurveyControlRecords = createLazyNamedPage(surveyControlLoader, 'SurveyControlRecords')

export const LearnedFaqsPage = createLazyNamedPage(learnedFaqsLoader, 'LearnedFaqsPage')
export const AnswerCardsPage = createLazyNamedPage(answerCardsLoader, 'AnswerCardsPage')
export const PropertyFaqCollectorLayout = createLazyNamedPage(
  propertyFaqCollectorLoader,
  'PropertyFaqCollectorLayout',
)
export const PropertyFaqCollectorOverview = createLazyNamedPage(
  propertyFaqCollectorLoader,
  'PropertyFaqCollectorOverview',
)
export const PropertyFaqCollectorAccountDetail = createLazyNamedPage(
  propertyFaqCollectorLoader,
  'PropertyFaqCollectorAccountDetail',
)
export const PropertyFaqCollectorRequestStatus = createLazyNamedPage(
  propertyFaqCollectorLoader,
  'PropertyFaqCollectorRequestStatus',
)
export const PublicMarkdownDocumentsPage = createLazyNamedPage(
  publicMarkdownDocumentsLoader,
  'PublicMarkdownDocumentsPage',
)

export const LeaseAuditReviewQueuePage = createLazyNamedPage(
  leaseAuditReviewLoader,
  'LeaseAuditReviewQueuePage',
)
export const LeaseAuditReviewDecisionPage = createLazyNamedPage(
  leaseAuditReviewLoader,
  'LeaseAuditReviewDecisionPage',
)
export const AuditCharterListPage = createLazyNamedPage(auditChartersLoader, 'AuditCharterListPage')
export const AuditCharterWorkspacePage = createLazyNamedPage(
  auditChartersLoader,
  'AuditCharterWorkspacePage',
)
export const AuditTrialLauncherPage = createLazyNamedPage(
  auditTrialsLoader,
  'AuditTrialLauncherPage',
)
export const AuditTrialRunPage = createLazyNamedPage(auditTrialsLoader, 'AuditTrialRunPage')
export const PgBossDashboardPage = createLazyNamedPage(pgBossDashboardLoader, 'PgBossDashboardPage')
export const DogfoodPage = createLazyNamedPage(voiceModeLoader, 'DogfoodPage')
export const VoiceOpsPage = createLazyNamedPage(voiceOpsLoader, 'VoiceOpsPage')

const routePrefetchers = {
  '/llm-evaluation': llmEvaluationLoader,
  '/renewal-health': renewalHealthLoader,
  '/charge-code-mappings': chargeCodeMappingsLoader,
  '/charge-code-explorer': chargeCodeExplorerLoader,
  '/active-products': activeProductsLoader,
  '/account-slack-notifications': accountSlackNotificationsLoader,
  '/assistant-bridge-packages': assistantBridgePackagesLoader,
  '/account-management': accountManagementLoader,
  '/yardi-etl-generator': yardiEtlGeneratorLoader,
  '/business-review-roi': businessReviewRoiLoader,
  '/customer-mrr': customerMrrLoader,
  '/snowflake-mrr': customerMrrLoader,
  '/route-activity': routeActivityLoader,
  '/conversation-qa': conversationQaLoader,
  '/front-email-lists': frontEmailListsLoader,
  '/entrata-integration-dashboard': entrataIntegrationDashboardLoader,
  '/appwork-residents': appWorkResidentsLoader,
  '/property-data-health': propertyDataHealthLoader,
  '/portfolio-assignments': portfolioAssignmentsLoader,
  '/portfolio-onboarding': portfolioOnboardingLoader,
  '/leasing-management': leasingManagementLoader,
  '/survey-control': surveyControlLoader,
  '/property-faq-collector': propertyFaqCollectorLoader,
  '/learned-faqs': learnedFaqsLoader,
  '/answer-cards': answerCardsLoader,
  '/public-markdown-documents': publicMarkdownDocumentsLoader,
  '/lease-audit-review': leaseAuditReviewLoader,
  '/lease-audit-charters': auditChartersLoader,
  '/lease-audit-trials': auditTrialsLoader,
  '/pg-boss-dashboard': pgBossDashboardLoader,
  '/voice-mode': voiceModeLoader,
  '/voice-ops': voiceOpsLoader,
  '/knowledge-gaps': knowledgeGapsLoader,
  '/record-payments': recordPaymentsLoader,
}

export const prefetchInternalRoute = (route) => {
  const prefetch = routePrefetchers[route]

  if (!prefetch) {
    return Promise.resolve(null)
  }

  return prefetch()
}
